import 'inventory-listing/components/SearchBar/SearchBar.scss';

import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { LocaleService } from '@sm360/widget-commons-core-services';

import * as Actions from 'inventory-listing/actions/listingUsedActions.js';

class ListingSearch extends React.Component {
    constructor(props) {
        super(props);
        this.searchChange = this.searchChange.bind(this);
    }

    searchChange(event) {
        event.preventDefault();
        this.props.actions.updateVehicleCriteria(event.target.value, 'textQuery');
    }

    render() {
        return (
            <div className="listing-used-payment-search">
                <div className="input-search">
                    <input
                        type="text"
                        placeholder={LocaleService.t('LOOKING_FOR')}
                        onChange={(value) => this.searchChange(value)}
                        value={this.props.textQuery}
                    />
                </div>
            </div>
        );
    }
}

ListingSearch.propTypes = {
    actions: PropTypes.shape({
        updateVehicleCriteria: PropTypes.func.isRequired,
    }),
    textQuery: PropTypes.string,
};

ListingSearch.displayName = 'ListingSearch';

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

export { ListingSearch };
export default connect(
    null,
    mapDispatchToProps
)(ListingSearch);



// WEBPACK FOOTER //
// ./client/src/components/SearchBar/SearchBar.jsx